export class FullAnalyzerAPConfig {
}
FullAnalyzerAPConfig.weightBearing_color = 0x00ff00;
FullAnalyzerAPConfig.nameLabel_backgroundColor = "rgba(0, 0, 0, 0.6)";
FullAnalyzerAPConfig.nameLabel_fontColor = "#ffffff";
//# sourceMappingURL=FullAnalyzerAPConfig.js.map